import CreditCheckPage from "join-form/pages/residential/credit-check/CreditCheckPage";

function ResidentialCreditCheckTemplate(props) {
  return <CreditCheckPage {...props} />;
}

export { ResidentialCreditCheckTemplate };
